import { 
  WAIT_INIT_ACCOUNTS, GET_ACCOUNTS, GET_ACCOUNTS_SUCCESS, GET_ACCOUNTS_FAIL, DELETE_CLOUD_ACCOUNT, DELETE_CLOUD_ACCOUNT_SUCCESS, DELETE_CLOUD_ACCOUNT_FAIL
} from '../actions/cloud-account/index';

import { 
  DELETE_ACCOUNT_SUCCESS
} from '../actions/account/index';

const doAction = (state, action) => {
  switch (action.type) {
    case WAIT_INIT_ACCOUNTS:
      return {
        ...state,
        status: WAIT_INIT_ACCOUNTS,
        accounts: [],
        errMsg: null,
        loading: true
      }
    case GET_ACCOUNTS:
      return {
        ...state,
        status: GET_ACCOUNTS,
        accounts: [],
        errMsg: null,
        loading: true
      }
    case GET_ACCOUNTS_SUCCESS:
      return {
        ...state,
        accounts: action.params.accounts,
        status: GET_ACCOUNTS_SUCCESS,
        loading: false
      }
    case GET_ACCOUNTS_FAIL:
      return {
        ...state,
        accounts: [],
        errMsg: action.params.errMsg,
        status: GET_ACCOUNTS_FAIL,
        loading: false
      }    
    case DELETE_CLOUD_ACCOUNT:
      return {
        ...state,
        status: DELETE_CLOUD_ACCOUNT,        
        popLoading: true
      }
    case DELETE_CLOUD_ACCOUNT_SUCCESS:
      return {
        ...state,
        status: DELETE_CLOUD_ACCOUNT_SUCCESS,
        accounts: action.params.accounts,
        popLoading: false
      }
    case DELETE_CLOUD_ACCOUNT_FAIL:
      return {
        ...state,
        status: DELETE_CLOUD_ACCOUNT_FAIL,
        errMsg: action.params.errMsg,
        popLoading: false
      }
    case DELETE_ACCOUNT_SUCCESS:
      return {
        ...state,
        status: WAIT_INIT_ACCOUNTS,
        accounts: [],
        errMsg: null,
        loading: true
      }
  default:
    return state;
  }
}

const cloudAccountReducers = (state = {
  accounts: [],
  errMsg: null,
  status: WAIT_INIT_ACCOUNTS,
  loading: false,
  popLoading: false
}, action) => {
  switch (action.type) {
    default:
      return doAction(state, action);
  }
}

export default cloudAccountReducers;